import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import PullToRefresh from "@/components/PullToRefresh";
import { ThemeProvider } from "@/lib/theme";
import { NotificationProvider } from "@/lib/notifications";
import { WriteQueueProvider } from "@/lib/writeQueue";
import WriteProgressFloater from "@/components/WriteProgressFloater";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <NotificationProvider>
          <WriteQueueProvider>
            <PullToRefresh>
              <App />
            </PullToRefresh>
            <WriteProgressFloater />
          </WriteQueueProvider>
        </NotificationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
